import { useRoutes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import routes from '@routes/routes';
import "../src/scss/common.scss"
function App() {
  const element = useRoutes(routes);
  return (
    <>
      {element}
      <Toaster position="top-center" toastOptions={{ duration: 5000 }} />
    </>
  );
}

export default App;
